exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-source-select-tree .el-select-dropdown__wrap{max-height:100%}", ""]);

// exports
